<template lang="pug">
  .text-gray-900.sticky.top-14.z-10.transition-all.duration-300.ease-out(
    :class="headerClasses" class="top-16"
  )
    .container.relative
      slot(v-if="renderCtaNavbar" name="cta_navbar")
      slot(v-else :toggle-header-dropdown-open="toggleHeaderDropdownOpen")
</template>

<script>
import { scrollListener } from '../../mixins/scrollListener';

export default {
  name: 'PurchasingHeader',
  mixins: [scrollListener],
  props: {
    alwaysDisplay: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      headerDropdownOpen: false,
      hero: null,
      scrolledPastHero: false,
    };
  },
  computed: {
    headerClasses () {
      if (this.headerDropdownOpen) return 'bg-white';
      return this.scrolled ? 'bg-white shadow-bottom-light md:shadow-none lg:shadow' : 'bg-transparent shadow-none';
    },

    renderCtaNavbar () {
      return this.$scopedSlots.cta_navbar && (this.scrolledPastHero || this.alwaysDisplay);
    },
  },
  created () {
    this.addScrollListener();
    window.addEventListener('scroll', this.trackNavigationCtaOnScroll);
  },
  mounted () {
    this.hero = document.getElementById('hero_component');
  },
  beforeDestroy () {
    this.removeScrollListener();
    window.removeEventListener('scroll', this.trackNavigationCtaOnScroll);
  },
  methods: {
    trackNavigationCtaOnScroll () {
      if (this.hero) {
        this.scrolledPastHero = (window.scrollY > (this.hero.offsetTop + this.hero.offsetHeight));
      }
    },
    toggleHeaderDropdownOpen () {
      this.headerDropdownOpen = !this.headerDropdownOpen;
    },
  },
};
</script>
